// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__27_Iq","label":"Section_label__ZnmUG","contentWrap":"Section_contentWrap__30D6e","footer":"Section_footer__2ahh7","footerInner":"Section_footerInner__19-gc"};